// components/ads/AdBlock.jsx
"use client";

// You can pass a slot, type, or adId prop for different ad placements or formats.
export default function AdBlock({
    slot = "default",
    className = "",
    ...props
}) {
    // You can later replace this <div> with your actual ad code (e.g., Google AdSense, custom, etc.)
    return (
        <div
            className={`adblock bg-gray-100 border border-dashed border-gray-300 rounded p-4 my-6 text-center text-sm text-gray-600 ${className}`}
            data-slot={slot}
            {...props}
        >
            {/* Placeholder content */}
            <span>
                Advertisement
                {slot !== "default" ? ` (${slot})` : ""}
                <br />
                {/* Replace below with your ad script/embed */}
                <span style={{ color: "#aaa" }}>Your ad here</span>
            </span>
        </div>
    );
}
